// The words @foodamigos/ui's chat parts show or read out, which the package has in English only (their `labels`
// props, 0.3.0); usePlatformAgentLabels hands them to each part.
export default {
  composer: {
    send: 'Send',
    stop: 'Stop',
    attach: 'Vedhæft filer',
    add: 'Tilføj',
    upload_files: 'Upload filer',
  },
  attachment: {
    uploading: 'Uploader {{percent}}%',
    uploading_file: 'Uploader {{name}}',
    retry: 'Prøv igen',
    remove: 'Fjern {{name}}',
    cancel: 'Annuller upload af {{name}}',
  },
  // What screen readers hear for each step's state, and the collapsed list's line ("4 steps · 1 failed and was retried").
  steps: {
    pending: 'Venter',
    running: 'Kører',
    done: 'Færdig',
    failed: 'Mislykkedes',
    denied: 'Afvist',
    background: 'Baggrund',
    summary_one: '{{count}} trin',
    summary_other: '{{count}} trin',
    failed_count_one: '{{count}} mislykkedes',
    failed_count_other: '{{count}} mislykkedes',
    retried_one: '{{count}} mislykkedes og blev prøvet igen',
    retried_other: '{{count}} mislykkedes og blev prøvet igen',
  },
  question: {
    suggested: 'Foreslået',
    withdrawn: 'Behøves ikke længere',
  },
  thread: {
    live_on: 'Live på {{domain}}',
    unread_one: '{{count}} nye',
    unread_other: '{{count}} nye',
    working: 'Arbejder på det',
  },
  // What screen readers hear for each row of a list that needs a look.
  checklist: {
    done: 'Færdig',
    running: 'I gang',
    waiting: 'Kræver opmærksomhed',
    failed: 'Mislykkedes',
    pending: 'Endnu ikke',
    skipped: 'Sprunget over',
  },
  lightbox: {
    enlarge: 'Forstør: {{label}}',
    close: 'Luk',
  },
};
